// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3su3w","header":"ReportDetails_header__1EByo","title":"ReportDetails_title__29gGC","left":"ReportDetails_left__1NgNL"};